<template>
    <div>
        <h1 class="display-heading">{{ pageTitle }}</h1>
        <div class="consultation-form">
            <div id="formPage0" v-show="currentPage===0">
                <p class="mb-3">Hi there! How can we help you today?</p>

                <p>I want to...</p>

                <div class="mt-3 consultation-choices">
                    <div class="row">
                        <div class="col-6 col-md-3">
                            <a href="javascript:void(0);" class="btn-consultation-choice"
                                @click="chooseOption('consultNow')">
                                <div class="btn-content">
                                    <div class="mb-2">
                                        <i class="fas fa-user-md fa-3x"></i>
                                    </div>
                                    <div>Consult A Doctor Now</div>
                                </div>
                            </a>
                        </div>
                        <div class="col-6 col-md-3">
                            <a href="javascript:void(0);" class="btn-consultation-choice"
                                @click="chooseOption('consultSchedule')">
                                <div class="btn-content">
                                    <div class="mb-2">
                                        <i class="fas fa-calendar-alt fa-3x"></i>
                                    </div>
                                    <div>Schedule An Appointment</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div id="formPage1" v-show="currentPage===1">
                <div class="mb-3">
                    <template>
                        <template v-if="onlineDoctors.length > 0">
                            <p class="mb-3">Here is a list of doctors available right now.</p>

                            <p>Now, please select a doctor of your choice:</p>
                            <div class="mt-3 consultation-doctor-choices">
                                <div class="row">
                                    <div v-for="(doctor, index) in onlineDoctors" :key="index" class="col-sm-6 mb-4">
                                        <a href="javascript:void(0);" class="btn-consultation-choice"
                                            @click="chooseAppointmentOnDemandDoctor(doctor.id)">
                                            <div class="btn-content">
                                                <div class="d-flex">
                                                    <div class="display-doctor-logo">
                                                        <div :style="{
                                                            'background-image': doctor.doctorProfilePhoto ? `url('//${doctor.doctorProfilePhoto}')`: '',
                                                            'background-size': 'cover',
                                                            'background-repeat': 'no-repeat'
                                                        }">
                                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                                x="0px" y="0px" viewBox="0 0 150 200"
                                                                enable-background="new 0 0 150 200"
                                                                xml:space="preserve">
                                                                <rect x="0" y="0" width="150" height="200" fill="#ccc">
                                                                </rect>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div class="ml-3 flex-fill">
                                                        <div class="mb-3">
                                                            <b>Doctor Name</b>
                                                            <div>
                                                                {{doctor.doctorName}}
                                                            </div>
                                                        </div>
                                                        <div class="mb-3">
                                                            <b>Hospital or Clinic Affiliation</b>
                                                            <div>
                                                                {{doctor.hospitalOrClinic}}
                                                            </div>
                                                        </div>
                                                        <div class="mb-3">
                                                            <b>Location</b>
                                                            <div>
                                                                {{doctor.location}}
                                                            </div>
                                                        </div>
                                                        <div class="mb-3">
                                                            <b>Specialty / Specialties</b>
                                                            <div>
                                                                {{doctor.doctorSpecialty}}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <b>Languages Speak</b>
                                                            <div>
                                                                {{doctor.languagesSpeak}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <p>Sorry, there's no available doctor right now.</p>
                        </template>
                    </template>
                </div>
                <button class="btn btn-secondary" type="button" @click="currentPage = 0">Back to Previous Page</button>
                <!-- <button class="btn btn-primary btn-primary-insv" type="button">Done</button> -->
            </div>
            <div id="formPage2" v-show="currentPage===2">
                <div class="mb-3">
                    <div class="card mb-5">
                        <div class="card-header">Search Doctors</div>
                        <div class="card-body">
                            <div class="mb-3">
                                <p>Please select the doctor specialty / specialties.</p>
                                <multiple-select-dropdown ref="doctorSpecialtySelect" :options="this.specialtyList"
                                    :selectedList="this.specialtySearch" @selected="updateSpecialty"
                                    :dismissOnSelect="true">
                                </multiple-select-dropdown>
                                <small>You may leave this field as empty if you want to view all available
                                    doctors.</small>
                            </div>
                            <button type="button" class="btn btn-primary btn-primary-insv" @click="searchDoctors">Search
                                Doctors</button>
                        </div>
                    </div>
                    <div ref="doctorResultContainer">
                        <template v-if="!isSearchInitiated">
                        </template>
                        <template v-else>
                            <template v-if="isLoading.searchDoctors">
                                <p>Searching for doctors...</p>
                                <p>Please wait.</p>
                            </template>

                            <template v-else>
                                <template v-if="doctorList.length > 0">
                                    <p class="mb-3">Here is a list of doctors available for appointments.</p>

                                    <p>Now, please select a doctor of your choice:</p>

                                    <div class="mt-3 consultation-doctor-choices">
                                        <div class="row">
                                            <div v-for="(doctor, index) in doctorList" :key="index"
                                                class="col-sm-6 mb-4">
                                                <a href="javascript:void(0);" :class="['btn-consultation-choice',
                                                {
                                                    'display': selectedDoctorId == doctor.id
                                                }]" @click="chooseAppointmentDoctor(doctor.id)">
                                                    <div class="btn-content">
                                                        <div class="d-flex">
                                                            <div class="display-doctor-logo">
                                                                <div :style="{
                                                                    'background-image': doctor.doctorProfilePhoto ? `url('//${doctor.doctorProfilePhoto}')`: '',
                                                                    'background-size': 'cover',
                                                                    'background-repeat': 'no-repeat'
                                                                }">
                                                                    <svg version="1.1"
                                                                        xmlns="http://www.w3.org/2000/svg" x="0px"
                                                                        y="0px" viewBox="0 0 150 200"
                                                                        enable-background="new 0 0 150 200"
                                                                        xml:space="preserve">
                                                                        <rect x="0" y="0" width="150" height="200"
                                                                            fill="#ccc"></rect>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                            <div class="ml-3 flex-fill">
                                                                <div class="mb-3">
                                                                    <b>Doctor Name</b>
                                                                    <div>
                                                                        {{doctor.doctorName}}
                                                                    </div>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <b>Hospital or Clinic Affiliation</b>
                                                                    <div>
                                                                        {{doctor.hospitalOrClinic}}
                                                                    </div>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <b>Location</b>
                                                                    <div>
                                                                        {{doctor.location}}
                                                                    </div>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <b>Specialty / Specialties</b>
                                                                    <div>
                                                                        {{doctor.doctorSpecialty}}
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <b>Languages Speak</b>
                                                                    <div>
                                                                        {{doctor.languagesSpeak}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <p>{{noDoctorAvailableForSearchMessage}}</p>
                                </template>
                            </template>
                        </template>
                    </div>
                </div>
                <button class="btn btn-secondary" type="button" @click="currentPage = 0">Back to Previous Page</button>
                &nbsp;

                <button v-show="selectedDoctorId" class="btn btn-primary btn-primary-insv" type="button"
                    @click="currentPage = 4">Choose Time Slot</button>
            </div>

            <!-- on demand appointment -->
            <div class="form-page3" v-show="currentPage===3">
                <div class="mb-3">
                    <p class="mb-3">Please confirm doctor details of your choice.</p>
                </div>
                <div v-if="selectedDoctor!=null" class="mt-3 consultation-doctor-choices display">
                    <div class="row">
                        <div class="col-sm-6 mb-4">
                            <div class="btn-consultation-choice display">
                                <div class="btn-content">
                                    <div class="d-flex">
                                        <div class="display-doctor-logo">
                                            <div :style="{
                                                'background-image': selectedDoctor.doctorProfilePhoto ? `url('//${selectedDoctor.doctorProfilePhoto}')`: '',
                                                'background-size': 'cover',
                                                'background-repeat': 'no-repeat'
                                            }">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                    viewBox="0 0 150 200" enable-background="new 0 0 150 200"
                                                    xml:space="preserve">
                                                    <rect x="0" y="0" width="150" height="200" fill="#ccc"></rect>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="ml-3 flex-fill">
                                            <div class="mb-3">
                                                <b>Doctor Name</b>
                                                <div>
                                                    {{selectedDoctor.doctorName}}
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <b>Hospital or Clinic Affiliation</b>
                                                <div>
                                                    {{selectedDoctor.hospitalOrClinic}}
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <b>Location</b>
                                                <div>
                                                    {{selectedDoctor.location}}
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <b>Specialty / Specialties</b>
                                                <div>
                                                    {{selectedDoctor.doctorSpecialty}}
                                                </div>
                                            </div>
                                            <div>
                                                <b>Languages Speak</b>
                                                <div>
                                                    {{selectedDoctor.languagesSpeak}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!!appointmentFailMessage" :class="[
                'mb-3',
                 {
                     'text-danger': apppointmentSaveFail,
                     'text-primary': !apppointmentSaveFail
                 }
                 ]">
                    {{appointmentFailMessage}}
                </div>
                <button class="btn btn-secondary mb-2" type="button" @click="currentPage = 1">Back to Doctor
                    List</button>&nbsp;
                <button class="btn btn-primary btn-primary-insv mb-2" type="button"
                    @click="proceedToCovid19Form">Consult Doctor Now</button>
            </div>

            <div class="form-page3" v-show="currentPage===4">
                <div class="mb-3">
                    <p>Please confirm the doctor details of your choice.</p>
                </div>
                <div v-if="selectedDoctor!==null" class="consultation-doctor-choices">
                    <div class="row">
                        <div class="col-sm-6 mb-4">
                            <div class="btn-consultation-choice display">
                                <div class="btn-content">
                                    <div class="d-flex">
                                        <div class="display-doctor-logo">
                                            <div :style="{
                                                'background-image': selectedDoctor.doctorProfilePhoto ? `url('//${selectedDoctor.doctorProfilePhoto}')`: '',
                                                'background-size': 'cover',
                                                'background-repeat': 'no-repeat'
                                            }">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                    viewBox="0 0 150 200" enable-background="new 0 0 150 200"
                                                    xml:space="preserve">
                                                    <rect x="0" y="0" width="150" height="200" fill="#ccc"></rect>
                                                </svg>
                                            </div>
                                        </div>
                                        <div class="ml-3 flex-fill">
                                            <div class="mb-3">
                                                <b>Doctor Name</b>
                                                <div>
                                                    {{selectedDoctor.doctorName}}
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <b>Hospital or Clinic Affiliation</b>
                                                <div>
                                                    {{selectedDoctor.hospitalOrClinic}}
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <b>Location</b>
                                                <div>
                                                    {{selectedDoctor.location}}
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <b>Specialty / Specialties</b>
                                                <div>
                                                    {{selectedDoctor.doctorSpecialty}}
                                                </div>
                                            </div>
                                            <div>
                                                <b>Languages Speak</b>
                                                <div>
                                                    {{selectedDoctor.languagesSpeak}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="mb-3">
                    <p>Please select desired appointment time</p>
                </div>

                <div class="card mb-3" v-for="(slotDay, index) in appointmentTimeslots" :key="index">
                    <div class="card-header">{{slotDay.date}}</div>
                    <div class="card-body">
                        <div class="consultation-times">
                            <a v-for="(slotTime, index2) in slotDay.times" :key="index2" href="javascript:void(0)"
                                @click="chooseAppointmentSlot(slotTime.sessionId, slotDay.date, `${convertToUserReadableTime(slotTime.startTime)} - ${convertToUserReadableTime(slotTime.endTime)}`)"
                                :class="[
                                    'btn-consultation-time-choice',
                                    {'display': selectedSessionId === slotTime.sessionId}
                                ]">
                                {{convertToUserReadableTime(slotTime.startTime)}} -
                                {{convertToUserReadableTime(slotTime.endTime)}}
                            </a>
                        </div>
                    </div>
                </div>

                <div v-show="!!appointmentFailMessage" :class="[
                'mb-3',
                 {
                     'text-danger': apppointmentSaveFail,
                     'text-primary': !apppointmentSaveFail
                 }
                 ]">
                    {{appointmentFailMessage}}
                </div>
                <button class="btn btn-secondary mb-2 mr-2" type="button" @click="currentPage = 2">Back to Doctor
                    List</button>
                <button v-show="selectedDoctorId && selectedSessionId" class="btn btn-primary btn-primary-insv mb-2"
                    type="button" @click="showPopupChosenTimeslotDialog">Confirm Appointment's Time</button>
            </div>

            <!-- covid19 form -->
            <div class="form-page4" v-show="currentPage===5">
                <questionnaire-covid19 ref="questionnaireCovid19" :isNew="true"
                    :patientName="patientName"
                    :patientIcNumber="patientIcNumber">
                </questionnaire-covid19>

                <div class="mt-3">
                    <button class="btn btn-secondary mb-2 mr-2" type="button" @click="covidFormBackPreviousStep">
                        Back to Previous Page
                    </button>
                    <button class="btn btn-primary btn-primary-insv mb-2" type="button" @click="validateCovid19Form">
                        Submit
                    </button>
                </div>
            </div>
        </div>

        <popup-modal ref="popupChosenTimeslotDialog" :hasCloseButton="false" title="Confirm Details">
            <template slot="content">
                <p>OK, doctor time slot is selected.</p>
                <p v-if="selectedDoctor!==null">Doctor Name: <b>{{selectedDoctor.doctorName}}</b></p>
                <p>Selected Date: <b>{{selectedSessionDate}}</b></p>
                <p>Selected Time: <b>{{selectedSessionTime}}</b></p>
            </template>

            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv"
                    @click="popupChosenTimeslotProceed">Proceed</button>
                <button type="button" class="btn btn-secondary" @click="dismissChosenTimeslotDialog">Choose Again</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupConsentDialog" :hasCloseButton="false" title="Confirm Details">
            <template slot="content">
                <template v-if="!isCreateOnDemand">
                    <p v-if="selectedDoctor!==null">Doctor Name: <b>{{selectedDoctor.doctorName}}</b></p>
                    <p>Selected Date: <b>{{selectedSessionDate}}</b></p>
                    <p>Selected Time: <b>{{selectedSessionTime}}</b></p>
                    <hr>
                </template>
                <div class="form-check mb-3">
                    <label class="form-check-label">
                        <input v-model="consentAllowViewConsultationHistory" type="checkbox" class="form-check-input">
                        <span>
                            I hereby agree and give my consent to the doctor to view my <b>previous consultation
                                records</b>.
                        </span>
                    </label>
                </div>
                <div class="form-check">
                    <label class="form-check-label">
                        <input v-model="consentAllowViewMedicalReport" type="checkbox" class="form-check-input">
                        <span>
                            I hereby agree and give my consent to the doctor to view my <b>medical reports</b>.
                        </span>
                    </label>
                </div>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv"
                    @click="consentDialogContinue">Confirm Appointment Details</button>
                <button type="button" class="btn btn-secondary" @click="consentDialogDismiss">Cancel</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupModalConfirmMailingAddress" :hasCloseButton="false" title="Confirm Mailing Address">
            <template slot="content">
                <p>Please confirm your mailing address, in the event of medicine(s) being prescribed by the doctor, the
                    medicine package will be sent to the following address.</p>

                <p v-if="!mailingAddress.isEditing">Click "Update Address" button before entering new or changing your mailing address.</p>

                <form @submit.prevent="validateForm" ref="addressForm">
                    <div id="confirmAddressForm" :class="{
                       'is-editing': mailingAddress.isEditing
                   }">
                        <div class="form-group">
                            <label>Address Line 1</label>
                            <input type="text" name="addressLine1" data-vv-as="address line 1"
                                data-vv-validate-on="blur" placeholder="Address Line 1"
                                v-model="mailingAddress.addressLine1" v-validate="'required'" :class="{
                                'form-control': mailingAddress.isEditing,
                                'form-control-plaintext': !mailingAddress.isEditing,
                                'is-invalid':  validationErrors.has('addressLine1')
                            }" :readonly="!mailingAddress.isEditing">

                            <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine1') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Address Line 2 (optional)</label>
                            <input type="text" placeholder="Address Line 2" v-model="mailingAddress.addressLine2"
                                :class="{
                                'form-control': mailingAddress.isEditing,
                                'form-control-plaintext': !mailingAddress.isEditing
                            }" :readonly="!mailingAddress.isEditing">
                        </div>

                        <div class="form-group">
                            <label>City</label>
                            <input type="text" name="city" data-vv-validate-on="blur" placeholder="City"
                                v-model="mailingAddress.addressCity" v-validate="'required'" :class="{
                                'form-control': mailingAddress.isEditing,
                                'form-control-plaintext': !mailingAddress.isEditing,
                                'is-invalid':  validationErrors.has('city')
                            }" :readonly="!mailingAddress.isEditing">
                            <div v-show="validationErrors.has('city')" class="invalid-feedback">
                                {{ validationErrors.first('city') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>State</label>
                            <select name="state" data-vv-validate-on="blur" v-model="mailingAddress.addressState"
                                v-validate="'required'" :class="{
                                'form-control': mailingAddress.isEditing,
                                'form-control-plaintext': !mailingAddress.isEditing,
                                'is-invalid':  validationErrors.has('state')
                            }" :disabled="!mailingAddress.isEditing">
                                <option :value="null">Choose...</option>
                                <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                    {{state.text}}
                                </option>
                            </select>
                            <div v-show="validationErrors.has('state')" class="invalid-feedback">
                                {{ validationErrors.first('state') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Postal Code</label>
                            <input type="text" name="postcode" placeholder="Postal Code" data-vv-validate-on="blur"
                                v-model="mailingAddress.addressPostcode" v-validate="'required'" :class="{
                                'form-control': mailingAddress.isEditing,
                                'form-control-plaintext': !mailingAddress.isEditing,
                                'is-invalid':  validationErrors.has('postcode')
                            }" :readonly="!mailingAddress.isEditing">
                            <div v-show="validationErrors.has('postcode')" class="invalid-feedback">
                                {{ validationErrors.first('postcode') }}
                            </div>
                        </div>
                    </div>
                </form>
                <p v-if="mailingAddress.isSaving">
                    {{mailingAddress.savingText}}
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="proceedConfirmMailingAddress">
                    <template v-if="!mailingAddress.isEditing">
                        Confirm Address
                    </template>
                    <template v-else>
                        Update and Proceed
                    </template>
                </button>
                <button v-if="!mailingAddress.isEditing" type="button" class="btn btn-primary"
                    @click="updateMailingAddress">Update Address</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Disclaimer">
            <template slot="content">
                <p>This Telehealth platform is only suitable for disease(s) which is/are considered as stable and under
                    well controlled currently.</p>
                <p>Please understand and agree to all of our <a
                        :href="termsAndConditionPatientsUrl" target="_blank">Terms & Conditions</a> before
                    proceeding.</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="disclaimerProceed">Agreed & Book
                    Consultation Now</button>
                <button type="button" class="btn btn-secondary" @click="disclaimerCancel">Cancel</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupModalLowCreditMessage" :hasCloseButton="false" title="Low Company Credit Balance">
            <template slot="content">
                <p>
                    Your company credit balance is currently low. You may be required to make payment either via FPX or credit card after this appointment is confirmed.
                </p>
                <p>
                    Do you still want to proceed?
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="proceedLowCredit">Proceed Booking Consultation</button>
                <button type="button" class="btn btn-secondary" @click="cancelLowCredit">Cancel</button>
            </template>
        </popup-modal>

        <popup-modal ref="popupMessageCheckDashboard" :hasCloseButton="false" title="Appointment Booked!">
            <template slot="content">
                <p>
                    Your request was sent to doctor !
                </p>
                <template v-if="isCreateOnDemand">
                    <p>
                        Please move to "Dashboard" page and wait for doctor's acceptance on your request.
                    </p>

                    <p v-if="isCompanyUser">
                        Request status will be changed from "Awaiting Doctor Response" to "Start Tele-Video" when this expense can be settled company's credit balance and personal limit is not exceeded.
                    </p>
                    <p v-else>
                        Request status will be changed from "Awaiting Doctor Response" to "Awaiting Payment" after doctor acceptance is done. Then click "Pay Now".
                    </p>
                </template>
                <template v-else>
                    <p v-if="isCompanyUser">
                        You will receive email notification when doctor accepts your request. Then make payment to confirm your scheduled appointment, if this expense is not paid by company account.
                    </p>
                    <p v-else>
                        You will receive email notification when doctor accepts your request. Then make payment to confirm your scheduled appointment.
                    </p>
                </template>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissAndGoToDashboard">
                    Move to Dashboard Page
                </button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import malaysiaStates from '@/config/malaysiaStates';
import moment from 'moment';
import {
    convertToUserReadableDateWithDay,
    convertToUserReadableTime
} from '@/utilities';
import multipleSelectDropdown from '@/components/multiple-select-dropdown';
import popupModal from '@/components/popup-modal';
import questionnaireCovid19 from '@/components/questionnaires/covid-19';
export default {
    'name': 'UserAddAppointment',
    'components': {
        popupModal,
        multipleSelectDropdown,
        questionnaireCovid19
    },
    'computed': {
        shouldShowCovid19Form () {
            return this.$store.state.shouldShowCovid19Form;
        },
        isCompanyUser () {
            return this.$store.state.user.isCompanyUser;
        },
        pageTitle () {
            switch (this.currentPage) {
            case 0:
                return 'Consult Now / Make Appointment';
            default:
                return this.isCreateOnDemand ? 'Consult Now' : 'Make Appointment';
            }
        },
        noDoctorAvailableForSearchMessage () {
            if (this.specialtySearch.length === 0) {
                return `Sorry, there's no doctor available for appointments within the next 2 weeks.`;
            } else if (this.specialtySearch.length === 1) {
                return `Sorry, there's no available doctor for appointments within the next 2 weeks for the selected specialty.`;
            } else {
                return `Sorry, there's no available doctor for appointments within the next 2 weeks for the selected specialties.`;
            }
        },
        termsAndConditionPatientsUrl () {
            return this.$store.state.operator.termsAndConditionPatientsUrl;
        },
        patientName () {
            return this.$store.state.user.fullName;
        },
        patientIcNumber () {
            return this.$store.state.user.identityCardNumber;
        }
    },
    'watch': {
        currentPage (pageNumber) {
            if (pageNumber === 2) {
                this.$refs.doctorSpecialtySelect.refresh();
            }
        },
        specialtyList (listData) {
            if (listData.length > 0) {
                let generalPractitioner = listData.find(d => d.text.includes('General Practitioner'));

                if (generalPractitioner && this.specialtySearch.length === 0) {
                    this.specialtySearch.push(generalPractitioner.value);
                    this.searchDoctors();
                }
            }
        }
    },
    data () {
        return {
            malaysiaStates,
            'currentPage': 0,
            'onlineDoctors': [],
            'apppointmentSaveFail': false,
            'appointmentFailMessage': null,
            'minDaysAllowed': 1,
            'maxDaysAllowed': 7,
            'appointmentDateFromMoment': null,
            'appointmentDateToMoment': null,
            'appointmentDateFrom': '',
            'appointmentDateTo': '',
            'appointmentTimeslots': [],
            'doctorList': [],
            'selectedDoctor': null,
            'selectedDoctorId': '',
            'selectedSessionId': '',
            'selectedSessionDate': '',
            'selectedSessionTime': '',
            'isCreateOnDemand': false,
            'consentAllowViewConsultationHistory': false,
            'consentAllowViewMedicalReport': false,
            'mailingAddress': {
                'savingText': '',
                'isSaving': false,
                'isEditing': false,
                'addressLine1': '',
                'addressLine2': '',
                'addressCity': '',
                'addressState': '',
                'addressPostcode': ''
            },
            'isLoading': {
                'searchDoctors': true
            },
            'isSearchInitiated': false,
            'specialtyList': [],
            'specialtySearch': [],
            'doctorResultScrollPosition': 0,
            'isLowConsultationCompanyCredit': false,
            'autoRetrieveDoctorList': true
        };
    },
    mounted () {
        this.retrieveSpecialtyList();

        this.axios.get('Profile/GetMyProfile').then(({
            data
        }) => {
            if (data.data) {
                this.mailingAddress.addressLine1 = data.data.mal1;
                this.mailingAddress.addressLine2 = data.data.mal2;
                this.mailingAddress.addressCity = data.data.mac;
                this.mailingAddress.addressState = data.data.mas;
                this.mailingAddress.addressPostcode = data.data.map;
            }
        });

        this.axios.get('CompanyCredit/CheckLowCredit').then(({
            data
        }) => {
            if (data.data) {
                this.isLowConsultationCompanyCredit = data.data.lcc;
            }
        });

        this.getOnlineDoctors();
    },
    beforeRouteLeave (to, from, next) {
        this.autoRetrieveDoctorList = false;
        next();
    },
    'methods': {
        searchDoctors () {
            this.isSearchInitiated = true;
            Promise.all([this.getMinDaysPriorAppointmentAllowed(), this.getMaxDaysAppointmentAllowed()])
                .then((result) => {
                    let minDaysSettings = result[0].data.data;
                    let maxDaysSettings = result[1].data.data;

                    this.minDaysAllowed = parseInt(minDaysSettings.v);
                    this.maxDaysAllowed = parseInt(maxDaysSettings.v);

                    // get today's date fresh (00:00:00)
                    let today = moment();

                    // get lower boundary
                    this.appointmentDateFromMoment = today.clone();
                    this.appointmentDateFromMoment = this.appointmentDateFromMoment.add(this.minDaysAllowed,
                        'days');
                    this.appointmentDateFrom = this.appointmentDateFromMoment.toISOString(true);

                    // get upper boundary
                    this.appointmentDateToMoment = today.clone();
                    this.appointmentDateToMoment = this.appointmentDateToMoment.add(this.maxDaysAllowed, 'days')
                        .endOf(
                            'day');
                    this.appointmentDateTo = this.appointmentDateToMoment.toISOString(true);

                    // get doctor timeslots
                    this.isLoading.searchDoctors = true;
                    this.axios.post('Doctor/GetDoctorTimeSlots', {
                        's': this.appointmentDateFrom,
                        'e': this.appointmentDateTo,
                        'ss': this.specialtySearch
                    }).then(({
                        data
                    }) => {
                        this.isLoading.searchDoctors = false;

                        let doctorTimeslotList = data.data;

                        this.doctorList = doctorTimeslotList.map((doctorItem) => {
                            let doctorProfile = doctorItem.d;
                            let timeslots = doctorItem.ts;

                            let doctorTimeslots = timeslots.map((slot) => ({
                                'sessionId': slot.si,
                                'startTime': slot.f,
                                'endTime': slot.t
                            }));

                            // test here
                            this.groupTimeslotsByDay(doctorTimeslots);

                            let specialties = doctorProfile.ds.map((s) => s.sn);
                            specialties = specialties.map(s => JSON.parse(s));
                            specialties = specialties.map(s => s.en);
                            return {
                                'id': doctorItem.di,
                                'doctorName': doctorProfile ? doctorProfile.n ? doctorProfile
                                    .n
                                    : '-' : '-',
                                'doctorEmail': doctorProfile ? doctorProfile.e ? doctorProfile
                                    .e
                                    : '-' : '-',
                                'doctorSpecialty': specialties.length > 0 ? specialties.join(
                                    ', ') : '-',
                                'timeslots': doctorTimeslots,
                                'doctorProfilePhoto': doctorProfile ? doctorProfile.piu
                                    ? doctorProfile.piu : '' : '',
                                'hospitalOrClinic': doctorProfile.dhca ? doctorProfile.dhca
                                    : '-',
                                'languagesSpeak': doctorProfile.l ? doctorProfile.l : '-',
                                'location': doctorProfile.loc ? doctorProfile.loc : '-'
                            };
                        });

                        // scroll to result...
                        this.$nextTick(() => {
                            let doctorResultScrollPosition = this.$refs.doctorResultContainer
                                .getBoundingClientRect().top + window.scrollY - document
                                .querySelector('.top-navigation').clientHeight;
                            document.body.scrollTop = doctorResultScrollPosition; // For Safari
                            document.documentElement.scrollTop =
                                    doctorResultScrollPosition; // For Chrome, Firefox, IE and Opera
                        });
                    });
                });
        },
        retrieveSpecialtyList () {
            this.axios.get('/Doctor/GetDoctorSpecialties').then(({
                data
            }) => {
                let list = data.data;

                // this.specialtyList = list.map((i) => {
                //     return {
                //         'value': i.si,
                //         'text': i.sn
                //     };
                // });

                for (let doctorSpecialty of list) {
                    this.specialtyList.push({
                        'value': doctorSpecialty.si,
                        'text': JSON.parse(doctorSpecialty.sn).en
                    });
                }
            });
        },
        // listen change of specialty, update,
        updateSpecialty (selectedValue) {
            // find index of selectedItem
            let selectedIndex = this.specialtySearch.findIndex((s) => s === selectedValue);

            if (selectedIndex > -1) {
                this.specialtySearch.splice(selectedIndex, 1);
            } else {
                this.specialtySearch.push(selectedValue);
            }
        },
        getOnlineDoctors () {
            this.isLoading.onlineDoctors = true;
            this.axios.get('/Doctor/GetOnlineDoctorsForConsultation').then(({
                data
            }) => {
                let pagedDataList = data.data;
                let doctorList = pagedDataList.l;

                this.onlineDoctors = doctorList.map((doctor) => {
                    let specialties = doctor.ds.map((s) => s.sn);

                    return {
                        'id': doctor.i,
                        'doctorName': doctor.n ? doctor.n : '-',
                        'doctorSpecialty': specialties.length > 0 ? specialties.join(', ') : '-',
                        'doctorEmail': doctor.e ? doctor.e : '-',
                        'languagesSpeak': doctor.l ? doctor.l : '-',
                        'doctorProfilePhoto': doctor ? doctor.piu ? doctor.piu : '' : '',
                        'hospitalOrClinic': doctor.dhca ? doctor.dhca : '-',
                        'location': doctor.loc ? doctor.loc : '-'
                    };
                });

                if (this.autoRetrieveDoctorList) {
                    setTimeout(() => {
                        this.getOnlineDoctors();
                    }, 10000);
                }
            });
        },
        getMinDaysPriorAppointmentAllowed () {
            return this.axios.get('SystemSetting/GetSettingValue', {
                'params': {
                    'settingName': 'consultation.appointment.min_days_prior'
                }
            });
        },
        getMaxDaysAppointmentAllowed () {
            return this.axios.get('SystemSetting/GetSettingValue', {
                'params': {
                    'settingName': 'consultation.appointment.max_days_prior'
                }
            });
        },
        chooseOption (option) {
            if (option === 'consultNow') {
                // this.getOnlineDoctors();
                this.currentPage = 1;
                this.isCreateOnDemand = true;
            } else if (option === 'consultSchedule') {
                this.currentPage = 2;
                this.isCreateOnDemand = false;
            }
        },
        chooseAppointmentOnDemandDoctor (doctorId) {
            let doctor = this.onlineDoctors.find(d => d.id === doctorId);

            if (doctor) {
                this.selectedDoctor = doctor;
                this.currentPage = 3;
            }
        },
        showPopupChosenTimeslotDialog () {
            this.$refs.popupChosenTimeslotDialog.show();
        },
        dismissChosenTimeslotDialog () {
            this.$refs.popupChosenTimeslotDialog.hide();
        },
        popupChosenTimeslotProceed () {
            this.$refs.popupChosenTimeslotDialog.hide().then(() => {
                this.proceedToCovid19Form();
            });
        },
        showDisclaimerBeforeProceed () {
            this.$refs.popupModalConfirmation.show();
        },
        disclaimerProceed () {
            this.$refs.popupModalConfirmation.hide();
            if (this.isCreateOnDemand) {
                this.createAppointment();
            } else {
                this.createAppointmentSchedule();
            }
        },
        disclaimerCancel () {
            this.$refs.popupModalConfirmation.hide();
        },
        createAppointment () {
            this.apppointmentSaveFail = false;
            this.appointmentFailMessage = 'Creating consultation request...';
            let covid19Questionnaire = this.$refs.questionnaireCovid19.getFormData();

            this.axios.post('Appointment/CreateOnDemandDoctorAppointment', {
                't': this.selectedDoctor.id,
                'cvch': this.consentAllowViewConsultationHistory,
                'cvmr': this.consentAllowViewMedicalReport,
                'c19q': covid19Questionnaire
            }).then(({
                data
            }) => {
                this.$refs.popupMessageCheckDashboard.show();
            }).catch(({
                response
            }) => {
                let responseData = response.data;
                this.apppointmentSaveFail = true;
                this.appointmentFailMessage = responseData.message;
            });
        },
        createAppointmentSchedule () {
            if (this.selectedDoctorId && this.selectedSessionId) {
                this.apppointmentSaveFail = false;
                this.appointmentFailMessage = 'Creating appointment schedule...';

                let covid19Questionnaire = this.$refs.questionnaireCovid19.getFormData();

                this.axios.post('Appointment/BookAppointmentWithTimeslot', {
                    't': this.selectedDoctor.id,
                    'si': this.selectedSessionId,
                    'cvch': this.consentAllowViewConsultationHistory,
                    'cvmr': this.consentAllowViewMedicalReport,
                    'c19q': covid19Questionnaire
                })
                    .then(({
                        data
                    }) => {
                        this.$refs.popupMessageCheckDashboard.show();
                    })
                    .catch(({
                        response
                    }) => {
                        let responseData = response.data;
                        this.apppointmentSaveFail = true;
                        this.appointmentFailMessage = responseData.message;
                    });
            } else {
                this.apppointmentSaveFail = true;
                this.appointmentFailMessage = 'Error creating appointment schedule. Details is incomplete.';
            }
        },
        groupTimeslotsByDay (timeslots) {
            let slots = [];

            let slotListWithDates = timeslots.map((slot) => ({
                'sessionId': slot.sessionId,
                'startTime': slot.startTime,
                'endTime': slot.endTime,
                'date': convertToUserReadableDateWithDay(slot.startTime),
                'startTimestamp': moment(slot.startTime).unix()
            }));

            slotListWithDates.forEach((slot) => {
                var found = slots.find(s => s.date === slot.date);

                if (found) {
                    found.times.push(slot);
                } else {
                    slots.push({
                        'date': slot.date,
                        'times': [slot]
                    });
                }
            });

            slots.forEach((slot) => {
                slot.times = slot.times.sort((s1, s2) => {
                    return s1.startTimestamp - s2.startTimestamp;
                });
            });

            return slots;
        },
        chooseAppointmentDoctor (doctorId) {
            // reset appointment session id
            if (this.selectedDoctorId !== doctorId) {
                this.selectedSessionId = '';
            }

            this.selectedDoctorId = doctorId;

            // generate timeslot list
            let selectedDoctor = this.doctorList.find(d => d.id === doctorId);

            if (selectedDoctor) {
                this.selectedDoctor = selectedDoctor;
                this.appointmentTimeslots = this.groupTimeslotsByDay(selectedDoctor.timeslots);
            } else {
                this.appointmentTimeslots = [];
            }
        },
        chooseAppointmentSlot (sessionId, selectedSessionDate, selectedSessionTime) {
            this.selectedSessionId = sessionId;
            this.selectedSessionDate = selectedSessionDate;
            this.selectedSessionTime = selectedSessionTime;

            this.showPopupChosenTimeslotDialog();
        },
        convertToUserReadableTime (input) {
            return convertToUserReadableTime(input);
        },
        showConsentDialog () {
            this.$refs.popupConsentDialog.show();
        },
        consentDialogContinue () {
            this.$refs.popupConsentDialog.hide().then(() => {
                this.shouldShowLowCreditMessage();
            });
        },
        consentDialogDismiss () {
            this.$refs.popupConsentDialog.hide();
        },
        shouldShowLowCreditMessage () {
            // if (this.isLowConsultationCompanyCredit) {
            //     this.$refs.popupModalLowCreditMessage.show();
            // } else {
            this.showConfirmMailingAddress();
            // }
        },
        proceedLowCredit () {
            this.$refs.popupModalLowCreditMessage.hide().then(() => {
                this.showConfirmMailingAddress();
            });
        },
        cancelLowCredit () {
            this.$refs.popupModalLowCreditMessage.hide();
        },
        showConfirmMailingAddress () {
            this.mailingAddress.isSaving = false;
            this.mailingAddress.savingText = '';

            this.validateForm().then((isValid) => {
                this.$validator.reset();
                if (!isValid) {
                    this.mailingAddress.isEditing = true;
                } else {
                    this.mailingAddress.isEditing = false;
                }
            }).finally(() => {
                this.$refs.popupModalConfirmMailingAddress.show();
            });
        },
        proceedConfirmMailingAddress () {
            if (this.mailingAddress.isEditing) {
                this.validateForm().then((isValid) => {
                    if (isValid) {
                        this.mailingAddress.isSaving = true;
                        this.mailingAddress.savingText = 'Updating your mailing address...';

                        this.axios.post('Profile/UpdateMailingAddress', {
                            'mal1': this.mailingAddress.addressLine1,
                            'mal2': this.mailingAddress.addressLine2,
                            'mac': this.mailingAddress.addressCity,
                            'mas': this.mailingAddress.addressState,
                            'map': this.mailingAddress.addressPostcode
                        }).then(() => {
                            this.$refs.popupModalConfirmMailingAddress.hide().then(() => {
                                this.showDisclaimerBeforeProceed();
                            });
                        }).catch(() => {
                            this.mailingAddress.savingText =
                                    'Error updating your mailing address. Please try again.';
                        });
                    }
                });
            } else {
                this.$refs.popupModalConfirmMailingAddress.hide().then(() => {
                    this.showDisclaimerBeforeProceed();
                });
            }
        },
        updateMailingAddress () {
            this.mailingAddress.isEditing = true;

            this.$nextTick(() => {
                if (document.querySelectorAll('#confirmAddressForm input').length > 0) {
                    document.querySelectorAll('#confirmAddressForm input')[0].focus();
                }
            });
        },
        validateForm () {
            return this.$validator.validateAll();
        },
        dismissAndGoToDashboard () {
            this.$refs.popupMessageCheckDashboard.hide().then(() => {
                this.$router.push({
                    'name': 'dashboard-user'
                });
            });
        },
        proceedToCovid19Form () {
            if (this.shouldShowCovid19Form) {
                this.currentPage = 5;
                window.scrollTo(0, 0);
            } else {
                // this.showConsentDialog();
                this.shouldShowLowCreditMessage();
            }
        },
        covidFormBackPreviousStep () {
            if (this.isCreateOnDemand) {
                this.currentPage = 3;
            } else {
                this.currentPage = 4;
            }
        },
        validateCovid19Form () {
            this.$refs.questionnaireCovid19.validateForm().then((isValid) => {
                if (isValid) {
                    this.showConsentDialog();
                }
            });
        },
        showConsentScreenForOnDemand () {
            this.$refs.popupConsentDialog.show();
        }
    }

};

</script>

<style>
    .consultation-choices .btn-consultation-choice {
        display: flex;
        background-color: #fff;
        color: #009344;
        border: 1px solid #009344;
        padding: 30px 15px;
        border-radius: .25rem;
        height: 100%;
        align-items: center;
        justify-content: center;
        transition: 0.1s ease-in-out;
    }

    .consultation-choices .btn-consultation-choice:hover,
    .consultation-choices .btn-consultation-choice:active {
        text-decoration: none;
        background-color: #009344;
        color: #fff;
    }

    .consultation-choices .btn-consultation-choice .btn-content {
        text-align: center;
    }

    .consultation-doctor-choices .btn-consultation-choice {
        display: block;
        background-color: #fff;
        border: 1px solid #009344;
        padding: 15px;
        border-radius: .25rem;
        height: 100%;
        transition: 0.1s ease-in-out;
        color: initial;
        text-decoration: none;
        transition: 0.1s ease-in-out;
    }

    .consultation-doctor-choices .btn-consultation-choice div {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .consultation-doctor-choices .btn-consultation-choice.display,
    .consultation-doctor-choices .btn-consultation-choice:not(.display):hover,
    .consultation-doctor-choices .btn-consultation-choice:not(.display):active {
        background-color: #009344;
        color: #fff;
    }

    .display-doctor-logo {
        min-width: 50px;
        max-width: 30%;
    }

    .display-doctor-logo>div {
        border: 1px solid #ccc;
    }

    .display-doctor-logo svg {
        width: 100%;
        visibility: hidden;
    }

    .consultation-times {
        display: flex;
        flex-wrap: wrap;
        margin: -5px;
    }

    .consultation-times .btn-consultation-time-choice {
        background-color: #fff;
        color: #009344;
        border: 1px solid #009344;
        padding: 10px;
        border-radius: .25rem;
        transition: 0.1s ease-in-out;
    }

    .consultation-times .btn-consultation-time-choice.display,
    .consultation-times .btn-consultation-time-choice:hover,
    .consultation-times .btn-consultation-time-choice:active {
        text-decoration: none;
        background-color: #009344;
        color: #fff;
    }

    .consultation-times .btn-consultation-time-choice {
        margin: 5px;
    }

    @media(min-width: 576px) {
        .consultation-times {
            margin: -10px;
        }

        .consultation-times .btn-consultation-time-choice {
            margin: 10px;
        }
    }

    #confirmAddressForm:not(.is-editing) label {
        font-weight: bold;
    }

</style>
